import { createStore, applyMiddleware } from "redux";

import storage from "redux-persist/lib/storage";
import { persistStore } from "redux-persist";
import { persist, deleteExpiredPersistsAsync } from "../utils/index";

import createSagaMiddleware from "redux-saga";

import createHistory from "history/createBrowserHistory";

import { routerMiddleware } from "react-router-redux";
import reducer, { rootSaga } from "./reduxRoot";
import sendError from "./sendError";
import { types as setuptypes, persistor } from "./setupRedux";
import { types as logintypes } from "../ui/Login/redux";

export const history = createHistory();

let store = null;

const persistConfig = {
	whitelist: ["router", "form"]
};

const rootReducer = (state, action) => {
	//reset to blank state on logout
	if (action.type === setuptypes.CLEAR_STATE) {
		//keep router state tho
		const { router } = state;
		state = { router };
	}
	return reducer(state, action);
};

export default async function configureStore() {
	return new Promise(async function(resolve, reject) {
		//middlewares
		//router
		const routerMiddlewareFunc = routerMiddleware(history);

		//saga
		const sagaMiddleware = createSagaMiddleware();

		//logger
		const logger = state => next => action => {
			if (action.payload && action.payload.pathname) {
				console.log(`Redux: ${action.type}   Route: ${action.payload.pathname}`);
			} else {
				console.log(`Redux: ${action.type}`);
			}
			next(action);
		};

		//send errors to backend
		const errors = state => next => action => {
			next(action);
			//ends with FAILED
			if (/FAILED$|ERROR$/.test(action.type)) {
				sendError(state.getState(), action, "WebApp error");
			}
		};

		const persistedReducer = persist("root", rootReducer, persistConfig);

		// Create Redux Store
		store = createStore(
			persistedReducer.root,
			undefined,
			applyMiddleware(routerMiddlewareFunc, sagaMiddleware, errors, logger)
		);

		await deleteExpiredPersistsAsync();

		const loca = Object.assign({}, window.location);

		// Persist Redux Store to storage.
		persistor.persistor = persistStore(store, null, () => {
			const rehydratedpersists = store.getState().setup.$persist;
			const rootpersist = rehydratedpersists.find(x => x && "router" in x);
		
			//run saga
			sagaMiddleware.run(rootSaga);

			store.dispatch({
				type: setuptypes.STORE_URI,
				payload: {
					uri: loca.pathname,
					params:
						rootpersist && rootpersist.router && rootpersist.router.location
							? rootpersist.router.location.state
							: undefined
				}
			});
			resolve({ store, persistor: persistor.persistor, history });
		});

		// if (config.enviroment === "DEV") {
		// 	persistor.purge();
		// }
	});
}



// WEBPACK FOOTER //
// ./src/boot/configureStore.js